import { useMemo } from "react";
import { useGetArchivedSlidesFoldersQuery } from "@/shared/services";
import type { TFolderWithChildren, TSlidesFolder } from "@/shared/types";

const buildNestedStructure = (
  allFolders: TSlidesFolder[],
): TFolderWithChildren[] => {
  const childrenByParent = new Map<string | null, TSlidesFolder[]>();
  for (const folder of allFolders) {
    const parent = folder.parentId ?? null;
    const bucket = childrenByParent.get(parent);
    if (bucket) bucket.push(folder);
    else childrenByParent.set(parent, [folder]);
  }
  const attach = (parentId: string | null): TFolderWithChildren[] =>
    (childrenByParent.get(parentId) ?? []).map((folder) => ({
      ...folder,
      children: attach(folder._id),
    }));
  return attach(null);
};

export const useGetArchivedFolders = () => {
  const { data, isLoading } = useGetArchivedSlidesFoldersQuery();

  const tree = useMemo(() => {
    if (!data) return [] as TFolderWithChildren[];
    return buildNestedStructure(data);
  }, [data]);

  return { folders: data ?? [], tree, isLoading };
};
